module.exports = __webpack_public_path__ + "img/arrow-down.2425ef0b.svg";